import React, { useEffect } from 'react';

const EBCReg = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50 py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-serif mb-4 text-zinc-900">
            Everest Base Camp Trek
          </h1>
          <h2 className="text-2xl text-zinc-700 mb-2">
            Participant Information & Registration Form
          </h2>
          <p className="text-zinc-600">
            Please fill out the form below to complete your registration
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-4 md:p-8">
          <iframe 
            aria-label='Everest Base Camp Trek – Participant Information & Registration Form' 
            frameBorder="0" 
            style={{
              height: '1800px',
              width: '100%',
              border: 'none',
              minHeight: '1800px'
            }}
            src='https://forms.zohopublic.in/trailzescapes1/form/EverestBaseCampTrekParticipantForm/formperma/ARoPR377tMPEygGfXo4ns8Bkz2HnXgRYTyypDRTKXVY'
            title="EBC Registration Form"
          />
        </div>

        <div className="mt-8 text-center text-zinc-600">
          <p>
            Need help? Contact us at{' '}
            <a href="mailto:info@trailz.in" className="text-emerald-700 hover:text-emerald-800 font-semibold">
              info@trailz.in
            </a>{' '}
            or call{' '}
            <a href="tel:+918149139073" className="text-emerald-700 hover:text-emerald-800 font-semibold">
              +91 8149139073
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EBCReg;
